class AddEditReportController {
    constructor(ReportServiceApi, toastr, ScriptInjectionService) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.report = null;
            this.data = {
                action: 'Create'
            };
            this.state = {
                initialReportValues: {
                    IsDeleted: false,
                    IsExternal: false,
                    Icon: ''
                },
                Icon: ''
            };
            this.validationErrors = [];
            this.fileTypes = ['pdf', 'html', 'zip'];
            this.report = this.resolve.report;
            if (this.report === null || angular.isUndefined(this.report.Name)) {
                this.report = {
                    Id: -1,
                    Name: '',
                    Icon: '',
                    Component: '',
                    Description: '',
                    Route: '',
                    ReportOrder: 9999, // Default Value (9999) for report ordering
                    IsDeleted: false,
                    IsExternal: false,
                    Filetype: 'pdf'
                };
                this.data.action = 'Create';
            }
            else {
                this.state.initialReportValues = {
                    IsDeleted: this.report.IsDeleted,
                    IsExternal: this.report.IsExternal,
                    Icon: this.report.Icon
                };
                this.state.Icon = this.report.Icon;
                this.data.action = 'Update';
            }
        };
        this.cancel = () => {
            this.dismiss();
        };
        this.makeSafe = (str) => {
            // Remove Angular brackets incase someone injects them
            str = str.replace(/\{/g, '');
            return str.replace(/\}/g, '');
        };
        this.updateName = () => {
            if (this.report.Name !== undefined) {
                this.report.Name = this.makeSafe(this.report.Name);
            }
        };
        this.updateDescription = () => {
            if (this.report.Description !== undefined) {
                this.report.Description = this.makeSafe(this.report.Description);
            }
        };
        this.updateIcon = () => {
            if (this.report.Icon !== undefined) {
                this.report.Icon = this.makeSafe(this.report.Icon);
            }
        };
        this.updateReportOrder = () => {
            if (this.report.ReportOrder !== undefined) {
                this.report.ReportOrder = Number(this.report.ReportOrder.toString().replace(/\D/g, ''));
            }
        };
        this.generateDescription = () => {
            // console.log(vm.report);
            if ((this.report.Description === '' || this.report.Description === undefined) && (this.report.Name !== '' || this.report.Name !== undefined)) {
                // vm.report.Description =
                let desc = this.report.Name;
                desc = desc.replace(/\B[A-Z]/, ' $&');
                desc = desc.replace(/report/gi, '');
                // console.log(desc);
                this.report.Description = desc;
            }
        };
        this.save = () => {
            // validate ReportOrder exists on client side as it defaults to 0 on server and that is a valid option.
            if (this.report.ReportOrder === undefined || this.report.ReportOrder === null) {
                this.toastr.error('You must supply a Report Order value.');
                return;
            }
            if (this.ScriptInjectionService.isInjectedScript(this.report.Name)) {
                this.toastr.error('Name contains illegal characters');
                return;
            }
            if (this.ScriptInjectionService.isInjectedScript(this.report.Description)) {
                this.toastr.error('Description contains illegal characters');
                return;
            }
            // Save changes to existing report or a newly defined one to the
            // database via the web api
            // tslint:disable-next-line:variable-name
            this.ReportServiceApi.saveReport(this.report).then((saveReport_Response) => {
                // ensure we have a response
                if (!angular.isUndefined(saveReport_Response)) {
                    // If there are errors, then act
                    if (saveReport_Response.data.errors.length > 0) {
                        this.validationErrors = saveReport_Response.data.errors;
                        angular.forEach(this.validationErrors, (validationError) => {
                            this.toastr.error(validationError);
                            // console.log(validationError);
                        });
                        return;
                    }
                    if (this.data.action === 'Update') {
                        if (this.report.IsDeleted !== this.state.initialReportValues.IsDeleted
                            || this.report.Icon !== this.state.initialReportValues.Icon
                            || this.report.IsExternal !== this.state.initialReportValues.IsExternal) {
                            // Report Updated and now we close the modal - and tell the page to refresh as the status is updated.
                            this.close({ $value: 'UpdatedStatus' });
                        }
                    }
                    // Report Added and now we close the modal. (No change to IsDeleted)
                    this.close({ $value: 'Saved' });
                }
                else {
                    // should never happen but may cause issues when we hang the timeout during debugging - this will handle the case where users experience a slow response and the timeout is hit.
                    this.toastr.info('Error Saving Details please double check all mandatory fields are completed.');
                }
            });
        };
        this.ReportServiceApi = ReportServiceApi;
        this.toastr = toastr;
        this.ScriptInjectionService = ScriptInjectionService;
    }
}
angular.module('app').component('addEditReportModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/Reports/add-edit-report.tpl.html',
    controllerAs: 'vm',
    controller: AddEditReportController
});
